import PropTypes from 'prop-types'

const antFormItemNamePropType = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
  PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
])

export default antFormItemNamePropType
